import {defineAsyncComponent} from 'vue';

const AllocationDecisionDetailPopup = defineAsyncComponent(() =>
  import('@/views/allocation/AllocationDecisionDetailPopup.vue'),
);

const AllocationDecisionDetailDVCQPopup = defineAsyncComponent(() =>
  import('@/views/allocation/AllocationDecisionDetailDVCQPopup.vue'),
);

const AllocationSTCSuperiorAddContentRevenueOtherPopup = defineAsyncComponent(() =>
  import('@/views/allocation/details/revenueOther/AllocationSTCSuperiorAddContentRevenueOtherPopup.vue'),
);
const AllocationAttachmentPreviewPopup = defineAsyncComponent(() =>
  import('@/views/allocation/summary/AllocationAttachmentPreviewPopup.vue'),
);
const AllocationRecAttachmentPreviewPopup = defineAsyncComponent(() =>
  import('@/views/allocation/summary/AllocationRecAttachmentPreviewPopup.vue'),
);
const EstimateDecisionExpenseInvestPopup = defineAsyncComponent(() =>
  import('@/views/allocation/details/expenseInvest/EstimateDecisionExpenseInvestPopup.vue'),
);
const EstimateDecisionExpenseRegularAddFieldPopup = defineAsyncComponent(() =>
  import('@/views/allocation/details/expenseRegular/EstimateDecisionExpenseRegularAddFieldPopup.vue'),
);
const AllocationSTCSuperiorAddExpenseOtherPopup = defineAsyncComponent(() =>
  import('@/views/allocation/details/expenseOther/AllocationSTCSuperiorAddExpenseOtherPopup.vue'),
);

const EstimateDecisionBudgetRevenueAgencyDetail = defineAsyncComponent(() =>
  import('@/views/estimateDecisions/revenueBudget/EstimateDecisionBudgetRevenueAgencyDetail.vue'),
);

const EstimateDecisionBudgetRevenueDicSummary = defineAsyncComponent(() =>
  import('@/views/estimateDecisions/revenueBudget/EstimateDecisionBudgetRevenueDicSummary.vue'),
);

const AllocationPendingSummaryRegularPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/AllocationPendingSummaryRegularPopup.vue'),
);
const EstimateDecisionBudgetRevenueSummaryBalance = defineAsyncComponent(() =>
  import('@/views/estimateDecisions/revenueBudget/EstimateDecisionBudgetRevenueSummaryBalance.vue'),
);
const EstimateDecisionExpenseRegularSummaryBalance = defineAsyncComponent(() =>
  import('@/views/estimateDecisions/expenseRegular/EstimateDecisionExpenseRegularSummaryBalance.vue'),
);

const EstimateDecisionExpenseTargetSourcePTCBalance = defineAsyncComponent(() =>
  import('@/views/estimateDecisions/EstimateDecisionExpenseTargetSourcePTCBalance.vue'),
);

const AllocationImplementRevenueOtherAddContentPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/RevenueOther/AllocationImplementRevenueOtherAddContentPopup.vue'),
);
const AllocationImplementAllocateByBalancePopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/RevenueOther/AllocationImplementAllocateByBalancePopup.vue'),
);

const AllocationImplementAddRegularPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/expenseRegular/AllocationImplementAddRegularPopup.vue'),
);
const EstimateInitialAddRegularPopup = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/popup/EstimateInitialAddRegularPopup.vue'),
);

const EstimateInitialAddRegularBusinessPopup = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/popup/EstimateInitialAddRegularBusinessPopup.vue'),
);

const EstInitialAggregateAddRegularBusinessPopup = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/popup/EstInitialAggregateAddRegularBusinessPopup.vue'),
);

const AllocationImplementAddRegularSCQPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/expenseRegular/AllocationImplementAddRegularSCQPopup.vue'),
);

const AllcationImplementProjectDetailPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/popup/AllcationImplementProjectDetailPopup.vue'),
);

const AllocationImplementGetDataProjectPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/popup/AllocationImplementGetDataProjectPopup.vue'),
);

const AllocationImplementEBAddRegularPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/AllocationImplementEBAddRegularPopup.vue'),
);

const AllocationImplementSubmitPTCPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/popup/AllocationImplementSubmitPTCPopup.vue'),
);
const EstimateDecisionExpenseRegularPTCAddFieldPopup = defineAsyncComponent(() =>
  import('@/views/estimateDecisions/expenseRegular/EstimateDecisionExpenseRegularPTCAddFieldPopup.vue'),
);

const EstimateDecisionExpenseBalanceDVCQAddContentPopup = defineAsyncComponent(() =>
  import(
    '@/views/estimateDecisions/estimateDecisionExpenseBalanceDVCQ/EstimateDecisionExpenseBalanceDVCQAddContentPopup.vue'
  ),
);

const EstimateDecisionExpenseRegularNotAutonomyDVCQAddContentPopup = defineAsyncComponent(() =>
  import(
    '@/views/estimateDecisions/estimateDecisionExpenseRegularDVCQ/EstimateDecisionExpenseRegularNotAutonomyDVCQAddContentPopup.vue'
  ),
);

const EstimateDecisionExpenseAdditionalDVCQAddContentPopup = defineAsyncComponent(() =>
  import(
    '@/views/estimateDecisions/estimateDecisionExpenseAdditionalDVCQ/EstimateDecisionExpenseAdditionalDVCQAddContentPopup.vue'
  ),
);

const AllocationImplementAddOrganizationClassificationPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/popup/AllocationImplementAddOrganizationClassificationPopup.vue'),
);

const AllocationImplementAddOrganizationPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/popup/AllocationImplementAddOrganizationPopup.vue'),
);

const EstimateInitialSectorWideAddOrganizationPopup = defineAsyncComponent(() =>
  import('@/views/estimateSectorWide/estInitial/popup/EstimateInitialSectorWideAddOrganizationPopup.vue'),
);

const AllocationImplementAddOrganizationCQPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/popup/AllocationImplementAddOrganizationCQPopup.vue'),
);

const ALCRevenueOtherSourceStructureTypePopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/popup/ALCRevenueOtherSourceStructureTypePopup.vue'),
);
const AllocationImplementRevenueOtherPTCAddContentPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/AllocationImplementRevenueOtherPTCAddContentPopup.vue'),
);
const AllocationImplementRevenueOtherSTCDistrictAddContentPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/AllocationImplementRevenueOtherSTCDistrictAddContentPopup.vue'),
);

const AllocationImplementSummaryDetailPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/popup/AllocationImplementSummaryDetailPopup.vue'),
);

const AllocationImplementSTCSummaryRevenueBudgetDetail = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/summary/AllocationImplementSTCSummaryRevenueBudgetDetail.vue'),
);
const AllocationReceiveSelfAddContentRevenueFeesPopup = defineAsyncComponent(() =>
  import('@/views/allocationReceiveSelf/revenueFees/AllocationReceiveSelfAddContentRevenueFeesPopup.vue'),
);
const AllocationReceiveSelfAddContentRevenueFeesSCQPopup = defineAsyncComponent(() =>
  import('@/views/allocationReceiveSelf/revenueFees/AllocationReceiveSelfAddContentRevenueFeesSCQPopup.vue'),
);
const AllocationImplementSubmitDVCQPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/popup/AllocationImplementSubmitDVCQPopup.vue'),
);

const AllocationRecExpenseBusinessAddRegularPopup = defineAsyncComponent(() =>
  import('@/views/estimateDecisions/AllocationRecExpenseBusinessAddRegularPopup.vue'),
);

const AllocationRecExpenseBusinessAddRegularProvincePopup = defineAsyncComponent(() =>
  import('@/views/estimateDecisions/AllocationRecExpenseBusinessAddRegularProvincePopup.vue'),
);

const AllocationReceiveDVCQPopup = defineAsyncComponent(() =>
  import('@/views/allocation/AllocationReceiveDVCQDetailPopup.vue'),
);

const AllocationReceiveHCSNPopup = defineAsyncComponent(() =>
  import('@/views/allocation/AllocationReceiveHCSNDetailPopup.vue'),
);

const AllocationSummaryExpenseBudgetCQSNPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/popup/AllocationSummaryExpenseBudgetCQSNPopup.vue'),
);

const NotificationAllocationReceive = defineAsyncComponent(() =>
  import('@/views/allocation/NotificationAllocationReceive.vue'),
);

const AllocationImplementSubmitSCQPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/popup/AllocationImplementSubmitSCQPopup.vue'),
);

const AllocationImplementAddTargetedSupplementPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/popup/AllocationImplementAddTargetedSupplementPopup.vue'),
);

const AllocationImplementAddProjectPCQPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/popup/AllocationImplementAddProjectPCQPopup.vue'),
);
const NotificationAllocationRevoke = defineAsyncComponent(() =>
  import('@/views/allocation/NotificationAllocationRevoke.vue'),
);

//Thêm quyết định giao sở chủ quản
const AllocationReceiveSCQPopup = defineAsyncComponent(() =>
  import('@/views/allocation/AllocationReceiveSCQPopup.vue'),
);

const AllocationReceiveSelfAddContentRevenueFeesSCQAutonomyPopup = defineAsyncComponent(() =>
  import('@/views/allocationReceiveSelf/revenueFees/AllocationReceiveSelfAddContentRevenueFeesSCQAutonomyPopup.vue'),
);

const AlcRecSelfProjectScqAddContentPopup = defineAsyncComponent(() =>
  import('@/views/allocationReceiveSelf/expenseProjectScq/AlcRecSelfProjectScqAddContentPopup.vue'),
);

const SelectionRevenueFeesPopup = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/popup/selectionRevenueFeesPopup.vue'),
);

const AllocationImplementAddOrganizationSTCDistrictPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/popup/AllocationImplementAddOrganizationSTCDistrictPopup.vue'),
);

const AlcImpAddRegularSCQPopup = defineAsyncComponent(() =>
  import('@/views/alcImpAdd/scq/details/popup/AlcImpAddRegularSCQPopup.vue'),
);
const AlcImpAddPendingRegularSCQPopup = defineAsyncComponent(() =>
  import('@/views/alcImpAdd/scq/details/popup/AlcImpAddPendingRegularSCQPopup.vue'),
);
const AlcImpAddPendingQuotaRegularSCQPopup = defineAsyncComponent(() =>
  import('@/views/alcImpAdd/scq/details/popup/AlcImpAddPendingQuotaRegularSCQPopup.vue'),
);
const AlcImpAddRegularSCQWarningPopup = defineAsyncComponent(() =>
  import('@/views/alcImpAdd/scq/details/popup/AlcImpAddRegularSCQWarningPopup.vue'),
);
const AlcImpAddRegularSCQViewDuplicatePopup = defineAsyncComponent(() =>
  import('@/views/alcImpAdd/scq/details/popup/AlcImpAddRegularSCQViewDuplicatePopup.vue'),
);
const AlcImpAddProgramScqAddProject = defineAsyncComponent(() =>
  import('@/views/alcImpAdd/scq/details/program/AlcImpAddProgramScqAddProject.vue'),
);

const AlcImpAddProgramScqAddOrg = defineAsyncComponent(() =>
  import('@/views/alcImpAdd/scq/details/program/AlcImpAddProgramScqAddOrg.vue'),
);

const AlcImpAddPendingQuotaProgramScq = defineAsyncComponent(() =>
  import('@/views/alcImpAdd/scq/details/program/AlcImpAddPendingQuotaProgramScq.vue'),
);

const AlcImpAddProgramScqWarning = defineAsyncComponent(() =>
  import('@/views/alcImpAdd/scq/details/program/AlcImpAddProgramScqWarning.vue'),
);

const AlcImpAddProgramScqProjectError = defineAsyncComponent(() =>
  import('@/views/alcImpAdd/scq/details/program/AlcImpAddProgramScqProjectError.vue'),
);

const AlcImpAddPendingProgramScqAddProject = defineAsyncComponent(() =>
  import('@/views/alcImpAdd/scq/details/impPending/program/AlcImpAddPendingProgramScqAddProject.vue'),
);

const AlcImpAddPendingProgramScqProjectError = defineAsyncComponent(() =>
  import('@/views/alcImpAdd/scq/details/impPending/program/AlcImpAddPendingProgramScqProjectError.vue'),
);

const AlcImpAddPendingProgramScqWarning = defineAsyncComponent(() =>
  import('@/views/alcImpAdd/scq/details/impPending/program/AlcImpAddPendingProgramScqWarning.vue'),
);

const AlcImpAdjProjectDetailScq = defineAsyncComponent(() =>
  import('@/views/alcImpAdj/scq/details/AlcImpAdjProjectDetailScq.vue'),
);

const AlcImpAdjProgramAddProjectScq = defineAsyncComponent(() =>
  import('@/views/alcImpAdj/scq/popup/AlcImpAdjProgramAddProjectScq.vue'),
);

const AlcImpAdjRegularDetailScq = defineAsyncComponent(() =>
  import('@/views/alcImpAdj/scq/details/regular/AlcImpAdjRegularDetailScq.vue'),
);

const AlcImpAdjRegularScqAddPopup = defineAsyncComponent(() =>
  import('@/views/alcImpAdj/scq/details/regular/AlcImpAdjRegularScqAddPopup.vue'),
);

const AlcImpAddSummaryBudgetDetailScq = defineAsyncComponent(() =>
  import('@/views/alcImpAdd/scq/details/AlcImpAddSummaryBudgetDetailScq.vue'),
);

export function allocationRegister(app) {
  app.component('AllocationSTCSuperiorAddContentRevenueOtherPopup', AllocationSTCSuperiorAddContentRevenueOtherPopup);
  app.component('AllocationAttachmentPreviewPopup', AllocationAttachmentPreviewPopup);
  app.component('AllocationRecAttachmentPreviewPopup', AllocationRecAttachmentPreviewPopup);
  app.component('AllocationDecisionDetailPopup', AllocationDecisionDetailPopup);
  app.component('AllocationDecisionDetailDVCQPopup', AllocationDecisionDetailDVCQPopup);
  app.component('EstimateDecisionExpenseInvestPopup', EstimateDecisionExpenseInvestPopup);
  app.component('AllocationSTCSuperiorAddExpenseOtherPopup', AllocationSTCSuperiorAddExpenseOtherPopup);
  app.component('EstimateDecisionExpenseRegularAddFieldPopup', EstimateDecisionExpenseRegularAddFieldPopup);
  app.component('EstimateDecisionBudgetRevenueAgencyDetail', EstimateDecisionBudgetRevenueAgencyDetail);
  app.component('EstimateDecisionBudgetRevenueDicSummary', EstimateDecisionBudgetRevenueDicSummary);
  app.component('AllocationPendingSummaryRegularPopup', AllocationPendingSummaryRegularPopup);
  app.component('EstimateDecisionBudgetRevenueSummaryBalance', EstimateDecisionBudgetRevenueSummaryBalance);
  app.component('EstimateDecisionExpenseRegularSummaryBalance', EstimateDecisionExpenseRegularSummaryBalance);
  app.component('EstimateDecisionExpenseTargetSourcePTCBalance', EstimateDecisionExpenseTargetSourcePTCBalance);
  app.component('AllocationImplementRevenueOtherAddContentPopup', AllocationImplementRevenueOtherAddContentPopup);
  app.component('AllocationImplementAllocateByBalancePopup', AllocationImplementAllocateByBalancePopup);
  app.component('AllocationImplementAddRegularPopup', AllocationImplementAddRegularPopup);
  app.component('EstimateInitialAddRegularPopup', EstimateInitialAddRegularPopup);
  app.component('EstimateInitialAddRegularBusinessPopup', EstimateInitialAddRegularBusinessPopup);
  app.component('EstInitialAggregateAddRegularBusinessPopup', EstInitialAggregateAddRegularBusinessPopup);
  app.component('AllocationImplementAddRegularSCQPopup', AllocationImplementAddRegularSCQPopup);
  app.component('AllcationImplementProjectDetailPopup', AllcationImplementProjectDetailPopup);
  app.component('AllocationImplementGetDataProjectPopup', AllocationImplementGetDataProjectPopup);
  app.component('AllocationImplementSummaryDetailPopup', AllocationImplementSummaryDetailPopup);
  app.component('AllocationImplementSubmitPTCPopup', AllocationImplementSubmitPTCPopup);
  app.component(
    'AllocationImplementAddOrganizationClassificationPopup',
    AllocationImplementAddOrganizationClassificationPopup,
  );
  app.component('AllocationImplementAddOrganizationPopup', AllocationImplementAddOrganizationPopup);
  app.component('EstimateInitialSectorWideAddOrganizationPopup', EstimateInitialSectorWideAddOrganizationPopup);
  app.component('AllocationImplementAddOrganizationCQPopup', AllocationImplementAddOrganizationCQPopup);
  app.component('EstimateDecisionExpenseRegularPTCAddFieldPopup', EstimateDecisionExpenseRegularPTCAddFieldPopup);
  app.component('EstimateDecisionExpenseBalanceDVCQAddContentPopup', EstimateDecisionExpenseBalanceDVCQAddContentPopup);
  app.component(
    'EstimateDecisionExpenseRegularNotAutonomyDVCQAddContentPopup',
    EstimateDecisionExpenseRegularNotAutonomyDVCQAddContentPopup,
  );
  app.component(
    'EstimateDecisionExpenseAdditionalDVCQAddContentPopup',
    EstimateDecisionExpenseAdditionalDVCQAddContentPopup,
  );
  app.component('ALCRevenueOtherSourceStructureTypePopup', ALCRevenueOtherSourceStructureTypePopup);
  app.component('AllocationImplementRevenueOtherPTCAddContentPopup', AllocationImplementRevenueOtherPTCAddContentPopup);
  app.component(
    'AllocationImplementRevenueOtherSTCDistrictAddContentPopup',
    AllocationImplementRevenueOtherSTCDistrictAddContentPopup,
  );
  app.component('AllocationImplementSTCSummaryRevenueBudgetDetail', AllocationImplementSTCSummaryRevenueBudgetDetail);
  app.component('AllocationImplementSubmitDVCQPopup', AllocationImplementSubmitDVCQPopup);
  app.component('AllocationRecExpenseBusinessAddRegularPopup', AllocationRecExpenseBusinessAddRegularPopup);
  app.component('AllocationReceiveSelfAddContentRevenueFeesPopup', AllocationReceiveSelfAddContentRevenueFeesPopup);
  app.component(
    'AllocationReceiveSelfAddContentRevenueFeesSCQPopup',
    AllocationReceiveSelfAddContentRevenueFeesSCQPopup,
  );
  app.component('AllocationReceiveDVCQDetailPopup', AllocationReceiveDVCQPopup);
  app.component('AllocationReceiveHCSNDetailPopup', AllocationReceiveHCSNPopup);
  app.component('AllocationSummaryExpenseBudgetCQSNPopup', AllocationSummaryExpenseBudgetCQSNPopup);
  app.component('NotificationAllocationReceive', NotificationAllocationReceive);
  app.component('AllocationImplementEBAddRegularPopup', AllocationImplementEBAddRegularPopup);

  app.component('AllocationImplementSubmitSCQPopup', AllocationImplementSubmitSCQPopup);
  app.component('AllocationImplementAddTargetedSupplementPopup', AllocationImplementAddTargetedSupplementPopup);
  app.component('AllocationImplementAddProjectPCQPopup', AllocationImplementAddProjectPCQPopup);
  app.component('NotificationAllocationRevoke', NotificationAllocationRevoke);
  app.component('AllocationReceiveSCQPopup', AllocationReceiveSCQPopup);

  app.component(
    'AllocationRecExpenseBusinessAddRegularProvincePopup',
    AllocationRecExpenseBusinessAddRegularProvincePopup,
  );
  app.component(
    'AllocationReceiveSelfAddContentRevenueFeesSCQAutonomyPopup',
    AllocationReceiveSelfAddContentRevenueFeesSCQAutonomyPopup,
  );
  app.component('AlcRecSelfProjectScqAddContentPopup', AlcRecSelfProjectScqAddContentPopup);
  app.component('SelectionRevenueFeesPopup', SelectionRevenueFeesPopup);
  app.component(
    'AllocationImplementAddOrganizationSTCDistrictPopup',
    AllocationImplementAddOrganizationSTCDistrictPopup,
  );
  app.component('AlcImpAddRegularSCQPopup', AlcImpAddRegularSCQPopup);
  app.component('AlcImpAddPendingRegularSCQPopup', AlcImpAddPendingRegularSCQPopup);
  app.component('AlcImpAddPendingQuotaRegularSCQPopup', AlcImpAddPendingQuotaRegularSCQPopup);
  app.component('AlcImpAddRegularSCQWarningPopup', AlcImpAddRegularSCQWarningPopup);
  app.component('AlcImpAddRegularSCQViewDuplicatePopup', AlcImpAddRegularSCQViewDuplicatePopup);
  app.component('AlcImpAddProgramScqAddProject', AlcImpAddProgramScqAddProject);
  app.component('AlcImpAddProgramScqAddOrg', AlcImpAddProgramScqAddOrg);
  app.component('AlcImpAddPendingQuotaProgramScq', AlcImpAddPendingQuotaProgramScq);
  app.component('AlcImpAddProgramScqWarning', AlcImpAddProgramScqWarning);
  app.component('AlcImpAddProgramScqProjectError', AlcImpAddProgramScqProjectError);
  app.component('AlcImpAddPendingProgramScqAddProject', AlcImpAddPendingProgramScqAddProject);
  app.component('AlcImpAddPendingProgramScqProjectError', AlcImpAddPendingProgramScqProjectError);
  app.component('AlcImpAddPendingProgramScqWarning', AlcImpAddPendingProgramScqWarning);
  app.component('AlcImpAdjProjectDetailScq', AlcImpAdjProjectDetailScq);
  app.component('AlcImpAdjProgramAddProjectScq', AlcImpAdjProgramAddProjectScq);
  app.component('AlcImpAdjRegularDetailScq', AlcImpAdjRegularDetailScq);
  app.component('AlcImpAdjRegularScqAddPopup', AlcImpAdjRegularScqAddPopup);
  app.component('AlcImpAddSummaryBudgetDetailScq', AlcImpAddSummaryBudgetDetailScq);
}
